import React from "react";
import Header from "./header";
import Footer from "./footer";

export default function Policy() {
    return (
        <>
            <Header />
            <section className="mainbody">
                <div className="stockdiv fade-in">
                    <p className="centeredp"><strong>Privacy Policy</strong></p>
                    <p className="centeredp">Last updated: September 26, 2026</p>

                    <p>At Invest With Knowledge, we take your privacy seriously. This policy explains what information we collect, why we collect it, and how it is used.</p>

                    <p className="centeredp"><strong><em><u>What We Collect</u></em></strong></p>
                    <p>We collect your name and email address only when you voluntarily subscribe to the Weekly Fave notification. No other personal information is collected.</p>

                    <p className="centeredp"><strong><em><u>How We Use Your Information</u></em></strong></p>
                    <p>Your name and email are used solely to send you the weekly stock pick notification. We do not use your information for advertising, analytics, or any other purpose.</p>

                    <p className="centeredp"><strong><em><u>Third Parties</u></em></strong></p>
                    <p>Your personal information is never sold, rented, or shared with any third party. Ever.</p>

                    <p className="centeredp"><strong><em><u>Data Storage</u></em></strong></p>
                    <p>Your information is stored securely and is only accessible to the Invest With Knowledge team.</p>

                    <p className="centeredp"><strong><em><u>Unsubscribe</u></em></strong></p>
                    <p>You may unsubscribe at any time by contacting us. Your data will be removed upon request.</p>

                    <p className="centeredp"><strong><em><u>Contact</u></em></strong></p>
                    <p>If you have any questions about this policy, please reach out through the Invest With Knowledge website.</p>
                </div>
            </section>
            <Footer />
        </>
    );
}
